import React, { createContext, useContext, useState } from "react";

const UsersContext = createContext();

// isExportOpen / setIsExportOpen come from the page, which also opens the export from its head bar
const UsersProvider = ({ children, isExportOpen, setIsExportOpen }) => {
    const [totalUsers, setTotalUsers] = useState(0);
    // Users checked in the table
    const [selectedUsers, setSelectedUsers] = useState([]);
    // Parameters of the last table query (sort), to export all the results in the same order
    const [tableQuery, setTableQuery] = useState({ orderBy: 0, orderDirection: 0 });

    return (
        <UsersContext.Provider value={{
            totalUsers, setTotalUsers,
            selectedUsers, setSelectedUsers,
            tableQuery, setTableQuery,
            isExportOpen, setIsExportOpen,
        }}>
            {children}
        </UsersContext.Provider>
    );
};

export function useUsersContext() {
    return useContext(UsersContext);
}

export { UsersContext, UsersProvider };
